export const productAllocation = "/product-allocation"
export const productAllocationDetails = "/carbon-savings/product-allocation"
export const plants = "/carbon-savings/plants"
